import shopifyWarehouseGenericDefaults from '../shopify-warehouse-generic/config.js';

export default {
  includes: ['shopify-warehouse-generic'],
  ...shopifyWarehouseGenericDefaults,
};
